import { render, staticRenderFns } from "./alias.vue?vue&type=template&id=711aa57c&scoped=true"
import script from "./alias.vue?vue&type=script&lang=js"
export * from "./alias.vue?vue&type=script&lang=js"
import style0 from "./alias.vue?vue&type=style&index=0&id=711aa57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711aa57c",
  null
  
)

export default component.exports